import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const SeoHelmet = () => {
    const currentCity: string = useSelector((state: any) => state.data.currentCity);
    const { t } = useTranslation('common');

    if (currentCity) {
        return (
            <Helmet>
                <title>{t(`seo_friendly.${currentCity}_home.title`)}</title>
                <meta name="description" content={t(`seo_friendly.${currentCity}_home.desc`)} />
                <meta name="keywords" content={t(`seo_friendly.${currentCity}_home.keywords`)} />
            </Helmet>
        );
    }

    return (
        <Helmet>
            <title>{t('seo_friendly.main_home.title')}</title>
            <meta name="description" content={t('seo_friendly.main_home.desc')} />
            <meta name="keywords" content={t('seo_friendly.main_home.keywords')} />
        </Helmet>
    );
};

export default SeoHelmet;
